import React, { useState } from 'react';
import { Search, ChevronDown } from 'lucide-react';
import { OfficerData } from '../types';
interface OfficerTableProps {
  data: OfficerData[];
  onOfficerClick?: (officer: OfficerData) => void;
}
export function OfficerTable({
  data,
  onOfficerClick
}: OfficerTableProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredData = data.filter(officer => officer.name.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8 flex flex-col" data-id="element-206">
      <div className="flex items-center justify-between p-4 border-b border-gray-100 flex-shrink-0" data-id="element-207">
        <h2 className="text-base font-bold text-[#3d3d3d] flex items-center gap-2" data-id="element-208">
          <div className="w-1.5 h-5 bg-[#5a7fa5] rounded-sm" data-id="element-209"></div>
          Performance by Loan Officer
        </h2>
        <div className="relative" data-id="element-210">
          <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-211" />
          <input type="text" placeholder="Search..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-8 pr-3 py-1.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-[#c9a84c]/20 focus:border-[#c9a84c] w-44 transition-all shadow-sm" data-id="element-212" />
        </div>
      </div>

      <div className="overflow-auto" style={{
      maxHeight: '520px'
    }} data-id="element-213">
        <table className="w-full text-xs text-left" data-id="element-214">
          <thead className="text-[10px] text-white uppercase bg-[#3d3d3d] sticky top-0 z-10" data-id="element-215">
            <tr data-id="element-216">
              <th className="px-3 py-3 font-semibold tracking-wider whitespace-nowrap" data-id="element-217">
                Officer
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider" data-id="element-218">Status</th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right" data-id="element-219">
                Created
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right" data-id="element-220">
                Conv.
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right" data-id="element-221">
                Disc.
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right" data-id="element-222">
                UW
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right" data-id="element-223">
                AWC
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right cursor-pointer hover:text-[#c9a84c] transition-colors whitespace-nowrap" data-id="element-224">
                Funded{' '}
                <ChevronDown size={12} strokeWidth={3} className="inline" data-id="element-225" />
              </th>
              <th className="px-2 py-3 font-semibold tracking-wider text-right whitespace-nowrap" data-id="element-226">
                Pull %
              </th>
            </tr>
          </thead>
          <tbody data-id="element-227">
            {filteredData.map((officer, index) => <tr key={officer.id} onClick={() => onOfficerClick?.(officer)} className={`border-b border-gray-100 hover:bg-[#c9a84c]/5 transition-colors cursor-pointer ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'}`} data-id="element-228">
                <td className="px-3 py-2.5 font-semibold text-[#5a7fa5] hover:text-[#4a6f95] hover:underline whitespace-nowrap" data-id="element-229">
                  {officer.name}
                </td>
                <td className="px-2 py-2.5" data-id="element-230">
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-[#5a7fa5]/10 text-[#5a7fa5] border border-[#5a7fa5]/20" data-id="element-231">
                    {officer.status}
                  </span>
                </td>
                <td className="px-2 py-2.5 text-right font-medium text-gray-700" data-id="element-232">
                  {officer.created}
                </td>
                <td className="px-2 py-2.5 text-right font-medium text-gray-700" data-id="element-233">
                  {officer.converted}
                </td>
                <td className="px-2 py-2.5 text-right font-medium text-gray-700" data-id="element-234">
                  {officer.discSent}
                </td>
                <td className="px-2 py-2.5 text-right font-medium text-gray-700" data-id="element-235">
                  {officer.subUw}
                </td>
                <td className="px-2 py-2.5 text-right font-medium text-gray-700" data-id="element-236">
                  {officer.awc}
                </td>
                <td className="px-2 py-2.5 text-right font-bold text-[#c9a84c]" data-id="element-237">
                  {officer.funded}
                </td>
                <td className="px-2 py-2.5" data-id="element-238">
                  <div className="flex items-center justify-end gap-1.5" data-id="element-239">
                    <div className="w-10 h-1.5 bg-gray-200 rounded-full overflow-hidden flex-shrink-0" data-id="element-240">
                      <div className="h-full bg-[#c9a84c] rounded-full" style={{
                    width: `${officer.pullThrough}%`
                  }} data-id="element-241"></div>
                    </div>
                    <span className="text-[#3d3d3d] w-7 text-right font-bold text-[11px]" data-id="element-242">
                      {officer.pullThrough}%
                    </span>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="px-4 py-2.5 border-t border-gray-100 bg-gray-50/50 text-[11px] text-gray-500 font-medium flex-shrink-0" data-id="element-243">
        Showing{' '}
        <strong className="text-[#3d3d3d]" data-id="element-244">{filteredData.length}</strong> of{' '}
        {data.length} officers
      </div>
    </div>;
}